// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"504b7d92","65":"1d47bdb4","259":"8ac01198","272":"e8026a90","315":"4afebac5","521":"d7082503","558":"a8c6da40","850":"3832085e"}[chunkId] + ".chunk.js";
};